@if (isNonProduction) {
  <div class="environment-notice" role="alert" data-test="environment-notice">
    <span>
      <span aria-hidden="true">⚠️</span> This is a <strong>non-production environment</strong> — not the real site.
      <a [href]="productionUrl">Go to the production site</a>
    </span>
  </div>
}
